var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 267,
    viewBox: "0 0 200 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9271 0.0470985C42.1927 1.68772 0 49.4377 0 104.193V241.651C0 249.078 8.97396 252.792 14.224 247.542L27.2031 237.891C30.6719 235.313 35.5365 235.813 38.4062 239.042L60.776 264.224C64.0312 267.479 69.3073 267.479 72.5625 264.224L93.7708 240.344C97.0885 236.61 102.917 236.61 106.229 240.344L127.437 264.224C130.693 267.479 135.969 267.479 139.224 264.224L161.594 239.042C164.464 235.813 169.328 235.308 172.797 237.891L185.776 247.542C191.026 252.792 200 249.073 200 241.651V100C200 43.7502 153.557 -1.65082 96.9271 0.0470985ZM66.6667 116.667C57.4635 116.667 50 109.203 50 100C50 90.7971 57.4635 83.3336 66.6667 83.3336C75.8698 83.3336 83.3333 90.7971 83.3333 100C83.3333 109.203 75.8698 116.667 66.6667 116.667ZM133.333 116.667C124.13 116.667 116.667 109.203 116.667 100C116.667 90.7971 124.13 83.3336 133.333 83.3336C142.536 83.3336 150 90.7971 150 100C150 109.203 142.536 116.667 133.333 116.667Z",
    fill: "#3333FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.0a2921694d6cda90ce8a1543f46109af.svg";
export { ForwardRef as ReactComponent };